class Store {
	seed = data => {
		if (!this.data) {
			this.data = data;
		} else {
			console.log(`Data already exists!`);
		}
	};
}

const store = new Store();

export default store;



// WEBPACK FOOTER //
// ./src/Store.js